var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM11.9418 8.05841C11.9418 6.98341 11.0751 6.11674 10.0001 6.11674C8.92514 6.11674 8.05847 6.99174 8.05847 8.05841C8.05847 9.13341 8.92514 10.0001 10.0001 10.0001C11.0751 10.0001 11.9418 9.13341 11.9418 8.05841ZM7.07514 12.5751C6.70014 13.1334 7.0918 13.8834 7.7668 13.8834H12.2335C12.9001 13.8834 13.3001 13.1251 12.9251 12.5751C12.3585 11.7334 11.2585 11.1667 10.0001 11.1667C8.7418 11.1667 7.6418 11.7334 7.07514 12.5751Z",
    fill: "#444656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/client.df1613fef1bd55a75f40d98fb928dba0.svg";
export { ForwardRef as ReactComponent };